export * from './lib/common-data-access-personal-details.module';
export * from './lib/+state';
import { PersonalDetailsPartialState } from './lib/+state/personal-details.reducer';
import * as PersonalDetailsSelectors from './lib/+state/personal-details.selectors';

export { PersonalDetailsSelectors, PersonalDetailsPartialState };
